import { FirebaseError } from 'firebase/app';

export class LocalizedError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'LocalizedError';
  }
}

export class MissingSearchParameterError extends LocalizedError {
  constructor(public param: string) {
    super('Die angeforderte URL ist fehlerhaft');
    this.name = 'MissingSearchParameterError';
  }
}

export class UnsupportedApiError extends Error {
  constructor() {
    super('Unsupported API operation');
    this.name = 'UnsupportedApiError';
  }
}

export class MissingObjectError extends Error {
  constructor() {
    super(`Missing object for operation`);
    this.name = 'MissingObjectError';
  }
}

export class InvalidContextError extends Error {
  constructor(message: string) {
    super(`Invalid context: ${message}`);
    this.name = 'InvalidContextError';
  }
}

export const errorText = (error: unknown) => {
  if (typeof error !== 'object' || error === null)
    return 'Es ist ein Fehler aufgetreten';

  // frontend internal error
  if (error instanceof LocalizedError) return error.message;

  // firebase error
  if (error instanceof FirebaseError) {
    if (error.code === 'auth/user-not-found') return 'Benutzer nicht gefunden';
    if (error.code === 'auth/wrong-password') return 'Passwort nicht korrekt';
    if (error.code === 'auth/weak-password') return 'Passwort zu unsicher';
    if (error.code === 'auth/invalid-action-code') return 'Code nicht gültig';
  }

  // backend error
  if ('status' in error) {
    if (error.status === 403)
      return 'Sie haben nicht die erforderlichen Rechte';
    if (error.status === 400 && 'data' in error) {
      const data = error.data as { type?: string };
      if (data?.type === 'DeadlineTooClose')
        return 'Ungültige Frist (zu kurzfristig)';
      if (data?.type === 'InvalidNewsletterArticle')
        return 'Der Newsletter enthält unvollständige Beiträge';
    }
  }

  return 'Es ist ein Fehler aufgetreten';
};
